import React from "react"
import Navbar from "../components/App/Navbar"
import Footer from "../components/App/Footer"
import Legals from "../components/App/Legals"
import Layout from "../components/App/Layout"
import Banner from "../components/Index/Banner"

import PSD2Bullets from "../components/Index/PSD2Bullets"
import PSD2Challenge from "../components/Index/PSD2Challenge"
import PSD2Overview from "../components/Index/PSD2Overview"


const Home = () => {
  return (
    <Layout>
      <Navbar />
      <Banner />
      <PSD2Overview />
      <PSD2Challenge />
      <PSD2Bullets />

      <Footer />
      <Legals />
    </Layout>
  )
}

export default Home